export const DEV_CLIENT_URL = 'https://www.economisemalin.fr/fr/connexion?back=plebicom';
export const STAGING_CLIENT_URL = 'https://www.economisemalin.fr/fr/connexion?back=plebicom';
export const PROD_CLIENT_URL = 'https://www.economisemalin.fr/fr/connexion?back=plebicom';



// WEBPACK FOOTER //
// ./src/constants/sso.js